import React from 'react';
import styles from './UserManagement.module.css';
import UserCard from './UserCard';

const UserList = ({ users, onDetail, onEdit, onPermission, onDelete, selectedUserIds = [], onSelectUser, onSelectAll }) => {
  if (!users.length) {
    return (
      <div className={styles.emptyState}>
        <p>Kullanıcı bulunamadı</p>
      </div>
    );
  }

  // Tüm kullanıcılar seçili mi?
  const allSelected = users.length > 0 && users.every(user => selectedUserIds.includes(user.id));

  return (
    <div>
      <div className={styles.userListHeader}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
          <input
            type="checkbox"
            checked={allSelected}
            onChange={e => onSelectAll(e.target.checked)}
          />
          Tümünü Seç
        </label>
      </div>
      <div className={styles.userList}>
        {users.map(user => (
          <UserCard
            key={user.id}
            user={user}
            onDetail={onDetail}
            onEdit={onEdit}
            onPermission={onPermission}
            onDelete={onDelete}
            selected={selectedUserIds.includes(user.id)}
            onSelect={() => onSelectUser(user.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default UserList; 